import styled from 'styled-components';

export const Ribbon = styled.div<{ backgroundColor: string }>`{
  font-size: 24px;
  font-weight: bold;
  color: #fff;

  --r: .4em; /* control the ribbon shape (the radius) */

  position: absolute;
  top: -2px;
  inset-inline: calc(-1*var(--r));
  text-align: center;
  line-height: 1.8;
  padding: 0 .5em calc(2*var(--r));
  border-radius: var(--r);
  --_g:100%/var(--r) calc(2*var(--r)) no-repeat;
  background:
    radial-gradient(100% 50% at right,#0005 98%,#0000 101%) 0    var(--_g),
    radial-gradient(100% 50% at left ,#0005 98%,#0000 101%) 100% var(--_g),
    conic-gradient(from 90deg at var(--r) calc(100% - 2*var(--r)),#0000 25%,${props => props.backgroundColor} 0)
      0 0/calc(100% - var(--r)) 100%;
}`;